if(!customElements.get('product-compare-bottom-sheet')){
    class ProductCompareBottomSheet extends HTMLElement {
        constructor(){
            super();

            this.numProducts = parseInt(this.dataset.numProducts) || 4;
            this.buttonPopup = this.querySelector('.button-popup');
            this.buttonClear = this.querySelector(".button-clear");

            this.content = this.querySelector('.bottom-sheet__content');
        }

        connectedCallback(){
            this.addedEventListeners = false;
            this.displayBottomSheet();

            this.onAddToCompareUnsubscriber = PubSub.subscribe(PubSub.events.addToCompareProduct, this.addToCompareProduct.bind(this));
            this.onRemoveFromCompareUnsubscriber = PubSub.subscribe(PubSub.events.removeFromCompareProduct, this.removeFromCompareProduct.bind(this));

            this.initializeSwiper();

            this.buttonPopup?.addEventListener("click", (e) => {
                e.preventDefault();
                const compareProducts = JSON.parse(getCookie('compare-products') || sessionStorage.getItem('compare-products') || '[]');
                if(compareProducts.length < 2) return;

                // Open product compare popup
                const productComparePopup = document.querySelector('product-compare-popup');
                if(productComparePopup){
                    productComparePopup.open();
                }
            });
        }

        disconnectedCallback(){
            if(this.onAddToCompareUnsubscriber){
                this.onAddToCompareUnsubscriber();
            }
            if(this.onRemoveFromCompareUnsubscriber){
                this.onRemoveFromCompareUnsubscriber();
            }
        }

        displayBottomSheet(){
            if(this.dataset.editMode === "true") {
                this.show();
                return;
            }

            const compareProducts = getCookie('compare-products') || sessionStorage.getItem('compare-products') || '[]';
            if(compareProducts === '[]' || compareProducts === null){
                this.collapse();
                this.hide();
                return;
            }

            this.show();
        }

        addToCompareProduct({ data: { productUrl } }){
            if(!productUrl) return;

            const compareProducts = JSON.parse(getCookie('compare-products')) || JSON.parse(sessionStorage.getItem('compare-products')) || [];
            if(compareProducts.length >= this.numProducts) return; // maximum product limit reached

            if(!compareProducts.includes(productUrl)){
                compareProducts.push(productUrl);

                sessionStorage.setItem('compare-products', JSON.stringify(compareProducts));
                setCookie('compare-products', JSON.stringify(compareProducts));
                sessionStorage.setItem('compare-products-max-product', this.numProducts);
            }
        
            this.displayBottomSheet();
        }

        removeFromCompareProduct({ data: { productUrl } }){
            if(!productUrl) return;

            const compareProducts = JSON.parse(getCookie('compare-products')) || JSON.parse(sessionStorage.getItem('compare-products')) || [];
            const updatedProducts = compareProducts.filter(url => url !== productUrl);
            
            sessionStorage.setItem('compare-products', JSON.stringify(updatedProducts));
            setCookie('compare-products', JSON.stringify(updatedProducts));

            this.displayBottomSheet();
        }

        showCompareProducts(){
            const compareProducts = JSON.parse(getCookie('compare-products') || sessionStorage.getItem('compare-products') || '[]');
            if(compareProducts.length === 0) {
                this.buttonPopup.disabled = true;
                return;
            }else if(compareProducts.length === 1){
                this.buttonPopup.disabled = true;
            }else{
                this.buttonPopup.disabled = false;
            }

            this.updateProductCount(compareProducts.length);

            const productItems = this.querySelectorAll('.product-item');
            productItems.forEach((item, index) => {
                const product = compareProducts[index];
                if(product){
                    this.getProduct(product, index);
                }else{
                    this.removeProduct(index);
                }
            });
        }

        updateProductCount(count){
            const countElement = this.querySelector(".num-products");
            if(countElement){
                countElement.textContent = `( ${count} / ${this.numProducts} ) `;
            }
        }

        getProduct(requestUrl, index){
            this.abortController?.abort();
            this.abortController = new AbortController();
            this.pendingRequestUrl = requestUrl;

            fetch(`${requestUrl}&section_id=product-compare-bottom-sheet-item`)
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');

                    // display products in bottom sheet
                    const productContainer = this.querySelector(`.product-item[data-index="${index + 1}"]`);
                    const productItem = html.querySelector('.product-item');

                    if(productItem && productContainer){
                        productContainer.innerHTML = productItem.innerHTML;

                        // add event listner to remove button
                        const removeButton = productContainer.querySelector('.button-remove');
                        if(removeButton){
                            removeButton.addEventListener('click', (e) => {
                                e.preventDefault();

                                const data = {
                                    productUrl: requestUrl
                                }
                                PubSub.publish(PubSub.events.removeFromCompareProduct, { data });

                                const checkboxData = {
                                    productUrl: requestUrl
                                }
                                PubSub.publish(PubSub.events.uncheckCompareProductCheckbox, { checkboxData });
                            });

                            removeButton.addEventListener('keydown', (e) => {
                                if(e.key !== 'Enter') return;
                                e.preventDefault();

                                const data = {
                                    productUrl: requestUrl
                                }
                                PubSub.publish(PubSub.events.removeFromCompareProduct, { data });

                                const checkboxData = {
                                    productUrl: requestUrl
                                }
                                PubSub.publish(PubSub.events.uncheckCompareProductCheckbox, { checkboxData });
                            });
                        }
                    }
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        removeProduct(index){
            const template = this.querySelector('template');
            if(!template) return;

            const productContainer = this.querySelector(`.product-item[data-index="${index + 1}"]`);
            if(productContainer){
                const emptyProductItem = template.content.cloneNode(true);
                productContainer.innerHTML = '';
                productContainer.appendChild(emptyProductItem);
            }
        }

        show(){
            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            if(!this.addedEventListeners){
                this.header = this.querySelector('.bottom-sheet__header');
                this.header?.addEventListener("click", this.toggle.bind(this));
                this.header?.addEventListener("keydown", (e) => {
                    if(e.key === 'Enter'){
                        this.toggle();
                    }
                });
                this.addedEventListeners = true;
            }

            this.buttonClear = this.querySelector(".button-clear");
            this.buttonClear?.addEventListener("click", this.clearAll.bind(this));
            this.buttonClear?.addEventListener("keydown", (e) => {
                if(e.key === 'Enter'){
                    this.clearAll(e);
                }
            });
        
            this.showCompareProducts();

            // make the room for the bottom sheet in 0.4s animation
            this.setRoomForBottomSheet(400);
        }

        setRoomForBottomSheet(duration = 400){
            const start = performance.now();

            const bottomAnimation = (now) => {
                const t = Math.min((now - start) / duration, 1);
                const bottomSheetHeight = this.dataset.expanded === "true"? this.offsetHeight : this.querySelector(".bottom-sheet__header").offsetHeight;

                document.body.style.setProperty('--product-compare-bottom-sheet', `${bottomSheetHeight * t}px`);

                if (t < 1) {
                    requestAnimationFrame(bottomAnimation.bind(this));
                }
            }

            requestAnimationFrame(bottomAnimation);
        }

        clearAll(e){    
            e.preventDefault();
                
            // Clear compare products
            sessionStorage.removeItem('compare-products');
            setCookie('compare-products', '[]');

            this.displayBottomSheet();
            
            // Uncheck all compare product checkboxes
            PubSub.publish(PubSub.events.uncheckAllCompareProductCheckboxes);
        }

        hide(){
            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');
            document.body.style.setProperty('--product-compare-bottom-sheet', `0px`);
        }

        toggle(){
            const isExpanded = this.getAttribute('data-expanded') === 'true';
            if(isExpanded){
                this.collapse();
            } else {
                this.expand();
            }

            this.setRoomForBottomSheet(10);
        }

        expand(){
            this.setAttribute('data-expanded', 'true');
            this.content.removeAttribute('inert', '');
        }

        collapse(){
            this.setAttribute('data-expanded', 'false');
            this.content.setAttribute('inert', '');
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector(".swiper-container");
            if(!this.swiperContainer) return;

            this.slides = this.querySelectorAll('.swiper-slide');
            if(this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const gap = parseInt(this.dataset.productGap) || 10;
            const swiperSettings = {
                slidesPerView: 'auto',
                spaceBetween: gap,
                freeMode: true,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true,
            };
            
            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();
        }
    }

    customElements.define('product-compare-bottom-sheet', ProductCompareBottomSheet);
}